import React from 'react';
import { Lightbulb, Zap, Shield } from 'lucide-react';
export const AboutUs = () => {
  return <section id="about" className="py-24 relative overflow-hidden" data-id="element-19">
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-[#171b31] to-transparent z-10" data-id="element-20"></div>
      <div className="absolute -top-40 right-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-21"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-22">
        <div className="max-w-3xl mx-auto text-center mb-16 reveal" data-id="element-23">
          <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#30c5e8]" data-id="element-24">
            ABOUT US
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-25">
            Revolutionizing Real Estate in{' '}
            <span className="text-gradient" data-id="element-26">Nigeria</span>
          </h2>
          <p className="text-lg text-gray-300" data-id="element-27">
            MUNISVerse is at the forefront of property technology, transforming
            how people discover, explore, and invest in real estate through
            immersive virtual reality experiences.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-28">
          <div className="reveal" data-id="element-29">
            <div className="relative" data-id="element-30">
              <div className="absolute inset-0 bg-gradient-to-tr from-[rgba(23,27,49,0.4)] to-[rgba(48,197,232,0.2)] rounded-xl z-10" data-id="element-31"></div>
              <img src="https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Virtual reality real estate experience" className="rounded-xl w-full h-auto relative z-0 mix-blend-luminosity" data-id="element-32" />
              <div className="absolute -bottom-4 -right-4 w-28 h-28 bg-glass rounded-xl p-3 neon-border z-20 flex items-center justify-center" data-id="element-33">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqKkDz2APUVgsC4j6KEjEb/vr_bukola_image.jpg" alt="Person wearing VR headset" className="w-full h-full object-cover rounded-lg" data-id="element-34" />
              </div>
            </div>
          </div>
          <div className="reveal" data-id="element-35">
            <h3 className="text-2xl font-bold mb-8 text-gradient" data-id="element-36">
              Why VR is the Future of Real Estate
            </h3>
            <div className="space-y-8" data-id="element-37">
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-38">
                <div className="flex" data-id="element-39">
                  <div className="flex-shrink-0 mt-1" data-id="element-40">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(48,197,232,0.2)]" data-id="element-41">
                      <Lightbulb size={20} className="text-[#30c5e8]" data-id="element-42" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-43">
                    <h4 className="text-xl font-semibold" data-id="element-44">
                      Immersive Experience
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-45">
                      Our VR technology allows clients to experience properties
                      in photorealistic detail from anywhere in the world,
                      saving time and resources.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-46">
                <div className="flex" data-id="element-47">
                  <div className="flex-shrink-0 mt-1" data-id="element-48">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(166,76,255,0.2)]" data-id="element-49">
                      <Zap size={20} className="text-[#a64cff]" data-id="element-50" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-51">
                    <h4 className="text-xl font-semibold" data-id="element-52">
                      Enhanced Decision Making
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-53">
                      Buyers and investors can make more confident decisions
                      with our interactive digital showrooms and customizable
                      property features.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-glass rounded-xl p-6 card-hover neon-border" data-id="element-54">
                <div className="flex" data-id="element-55">
                  <div className="flex-shrink-0 mt-1" data-id="element-56">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(183,138,255,0.2)]" data-id="element-57">
                      <Shield size={20} className="text-[#b78aff]" data-id="element-58" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-59">
                    <h4 className="text-xl font-semibold" data-id="element-60">
                      Future-Proof Investment
                    </h4>
                    <p className="mt-2 text-gray-300" data-id="element-61">
                      Developers who embrace our VR solutions stand out in the
                      market, attracting more clients and closing deals faster.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};